import sdl from '@jds/react-generated-sdl/SwadeshTag';
import type { SwadeshTagProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic } from '../logic';

const Component = (props: SwadeshTagProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const {
    size = 'medium',
    kind = 'chip',
    disabled = false,
    active = false,
    custom = '',
    ...rest
  } = props as any;
  return createComponent(
    json,
    { size, kind, disabled, active, ...rest },
    'SwadeshTag',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const SwadeshTag = withLogic(Component) as React.FC<SwadeshTagProps> & {
  slotName?: string;
};

SwadeshTag.displayName = 'SwadeshTag';
SwadeshTag.slotName = 'swadesh_tag';

export { SwadeshTag, type SwadeshTagProps };
